import axios from "@/index";
const scanStatistics = {
  state: {
    scanInfo: "",
    scanFailInfo: [],
    scanSelectInfo: "",
    scanStatisticsInfo: ""
  },
  getters: {},
  actions: {
    getScanStatisticsView: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setScanStatisticsView",
                (state, { scanStatisticsInfo: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getScanStatistics: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setScanStatistics",
                (state, { scanSelectInfo: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getScanRecord: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setScanRecord", (state, { scanInfo: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getShootInfoPage: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setShootInfoPage",
                (state, { scanFailInfo: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setScanRecord(state, action) {
      state.scanInfo = action.scanInfo;
    },
    setShootInfoPage(state, action) {
      state.scanFailInfo = action.scanFailInfo;
    },
    setScanStatistics(state, action) {
      state.scanSelectInfo = action.scanSelectInfo;
    },
    setScanStatisticsView(state, action) {
      state.scanStatisticsInfo = action.scanStatisticsInfo;
    }
  }
};
export default scanStatistics;
